import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useAppNotification } from "@/modules/app-notification";

export const useGenericFormErrorNotification = (isError) => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();

  useEffect(() => {
    if (isError) {
      notify.error({ title: t("form:error.invalid"), placement: "topLeft" });
    }
  }, [isError]);
};
